import React from 'react'
import TrophyCell from "./TrophyCell";
import { BADGE_TYPE } from '../../../../services/badging/constants';
import BadgeCell from "./BadgeCell";
import cloneDeep from 'lodash.clonedeep';
import { useTranslation } from 'react-i18next';

function BadgingTableComingSoon() {
  const {t} = useTranslation("badging_report")
  return <div className='badging-table-coming-soon'>{t("Coming Soon!")}</div>
}

const columns = [
  {
    label: 'Last Name',
    render: x => x.lastName,
  },
  {
    label: 'First Name',
    render: x => x.firstName,
  },
  {
    label: 'Tutoring Time',
    render:  x => {
      if (!("activityCount" in x)) return <BadgingTableComingSoon />
      const { sessionTime } = x
      const style = {};
      if (sessionTime >= 10) {
        style.background = "var(--at-grade)"
        style.color = "#222"
      }
      if (sessionTime >= 30) style.background = "var(--ahead-grade)"
      return <div className="badging-table-metric-cell" style={style}>{sessionTime} min</div>
    },
    colSpan: x => ("activityCount" in x) ? 1 : 2,
  },
  {
    label: 'Stories Read',
    render: x => {
      const { activityCount } = x
      const style = {};
      if (activityCount > 0) {
        style.background = "var(--at-grade)"
        style.color = "#222"
      }
      if (activityCount > 4) style.background = "var(--ahead-grade)"
      return <div className="badging-table-metric-cell" style={style}>{activityCount}</div>
    },
    isHidden: x => ("sessionTime" in x) ? false : true,
  },
  {
    label: 'Badges Earned',
    render: x => <TrophyCell value={x.earnedCount} />,
    cellClassName: 'badgingTableAwardCell',
  },
  {
    label: 'New Awards',
    render: x => {
      let newAwardCount = 0;
      for (const badgeTypeId of x.studentCellSelection) {
        const badges = x.badges[badgeTypeId] || [];
        for (const badge of badges) {
          if (!badge.awarded) newAwardCount++;
        }
      }
      return <TrophyCell isNew value={newAwardCount} />
    },
    cellClassName: 'badgingTableAwardCell',
  },
  {
    label: 'Total Sessions',
    badgeTypeId: `${BADGE_TYPE.NUM_SESSIONS}|EN_US`,
    locale: "EN_US",
    render: x => {
      const badgeType = `${BADGE_TYPE.NUM_SESSIONS}|EN_US`;
      return <BadgeCell
        badges={x.badges[badgeType]}
        selected={x.studentCellSelection.includes(badgeType)}
        onClick={() => x.toggleCell(x.studentId, badgeType)}
      />
    }
  },
  {
    label: 'Total Sessions',
    badgeTypeId: `${BADGE_TYPE.NUM_SESSIONS}|ES_MX`,
    locale: "ES_MX",
    render: x => {
      const badgeType = `${BADGE_TYPE.NUM_SESSIONS}|ES_MX`;
      return <BadgeCell
        badges={x.badges[badgeType]}
        selected={x.studentCellSelection.includes(badgeType)}
        onClick={() => x.toggleCell(x.studentId, badgeType)}
      />
    }
  },
  {
    label: 'Minutes This Week',
    badgeTypeId: `${BADGE_TYPE.NUM_MINUTES}|EN_US`,
    locale: "EN_US",
    render: x => {
      const badgeType = `${BADGE_TYPE.NUM_MINUTES}|EN_US`;
      return <BadgeCell
        badges={x.badges[badgeType]}
        selected={x.studentCellSelection.includes(badgeType)}
        onClick={() => x.toggleCell(x.studentId, badgeType)}
      />
    }
  },
  {
    label: 'Minutes This Week',
    badgeTypeId: `${BADGE_TYPE.NUM_MINUTES}|ES_MX`,
    locale: "ES_MX",
    render: x => {
      const badgeType = `${BADGE_TYPE.NUM_MINUTES}|ES_MX`;
      return <BadgeCell
        badges={x.badges[badgeType]}
        selected={x.studentCellSelection.includes(badgeType)}
        onClick={() => x.toggleCell(x.studentId, badgeType)}
      />
    }
  },
  {
    label: 'WCPM',
    badgeTypeId: `${BADGE_TYPE.NEW_WCPM_HIGH}|EN_US`,
    locale: "EN_US",
    render: x => {
      const badgeType = `${BADGE_TYPE.NEW_WCPM_HIGH}|EN_US`;
      return <BadgeCell
        badges={x.badges[badgeType]}
        selected={x.studentCellSelection.includes(badgeType)}
        onClick={() => x.toggleCell(x.studentId, badgeType)}
      />
    }
  },
  {
    label: 'WCPM',
    badgeTypeId: `${BADGE_TYPE.NEW_WCPM_HIGH}|ES_MX`,
    locale: "ES_MX",
    render: x => {
      const badgeType = `${BADGE_TYPE.NEW_WCPM_HIGH}|ES_MX`;
      return <BadgeCell
        badges={x.badges[badgeType]}
        selected={x.studentCellSelection.includes(badgeType)}
        onClick={() => x.toggleCell(x.studentId, badgeType)}
      />
    }
  },
  {
    label: 'Skills Scaffold Graduation',
    badgeTypeId: `${BADGE_TYPE.SKILLS_SCAFFOLD_GRADUATION}|EN_US`,
    locale: "EN_US",
    render: x => {
      const badgeType = `${BADGE_TYPE.SKILLS_SCAFFOLD_GRADUATION}|EN_US`;
      return <BadgeCell
        badges={x.badges[badgeType]}
        selected={x.studentCellSelection.includes(badgeType)}
        onClick={() => x.toggleCell(x.studentId, badgeType)}
      />
    }
  },
  {
    label: 'Skills Scaffold Graduation',
    badgeTypeId: `${BADGE_TYPE.SKILLS_SCAFFOLD_GRADUATION}|ES_MX`,
    locale: "ES_MX",
    render: x => {
      const badgeType = `${BADGE_TYPE.SKILLS_SCAFFOLD_GRADUATION}|ES_MX`;
      return <BadgeCell
        badges={x.badges[badgeType]}
        selected={x.studentCellSelection.includes(badgeType)}
        onClick={() => x.toggleCell(x.studentId, badgeType)}
      />
    }
  },
  {
    label: 'New High',
    badgeTypeId: `${BADGE_TYPE.NEW_HIGH}|EN_US`,
    locale: "EN_US",
    render: x => {
      const badgeType = `${BADGE_TYPE.NEW_HIGH}|EN_US`;
      return <BadgeCell
        badges={x.badges[badgeType]}
        selected={x.studentCellSelection.includes(badgeType)}
        onClick={() => x.toggleCell(x.studentId, badgeType)}
      />
    },
  },
  {
    label: 'New High',
    badgeTypeId: `${BADGE_TYPE.NEW_HIGH}|ES_MX`,
    locale: "ES_MX",
    render: x => {
      const badgeType = `${BADGE_TYPE.NEW_HIGH}|ES_MX`;
      return <BadgeCell
        badges={x.badges[badgeType]}
        selected={x.studentCellSelection.includes(badgeType)}
        onClick={() => x.toggleCell(x.studentId, badgeType)}
      />
    }
  },
  {
    label: 'Built By You',
    badgeTypeId: `${BADGE_TYPE.CUSTOM}|EN_US`,
    locale: "EN_US",
    render: x => {
      const badgeType = `${BADGE_TYPE.CUSTOM}|EN_US`;
      return <BadgeCell
        badges={x.badges[badgeType]}
        selected={x.studentCellSelection.includes(badgeType)}
        onClick={() => x.toggleCell(x.studentId, badgeType)}
        sort="byDate"
      />
    },
    cellClassName: 'badgingTableCustomCell'
  },
  {
    label: 'Built By You',
    badgeTypeId: `${BADGE_TYPE.CUSTOM}|ES_MX`,
    locale: "ES_MX",
    render: x => {
      const badgeType = `${BADGE_TYPE.CUSTOM}|ES_MX`;
      return <BadgeCell
        badges={x.badges[badgeType]}
        selected={x.studentCellSelection.includes(badgeType)}
        onClick={() => x.toggleCell(x.studentId, badgeType)}
        sort="byDate"
      />
    },
    cellClassName: 'badgingTableCustomCell'
  }
]

export function getBadgingTableColumns(badgingLocale) {
  const cols = cloneDeep(columns);
  const output = [];
  for (const col of cols) {
    const {locale} = col;
    if (!locale) output.push(col);
    else {
      if (badgingLocale?.english && locale === 'EN_US') output.push(col);
      if (badgingLocale?.spanish && locale === 'ES_MX') output.push(col);
    }
  }
  return output;
}